import { routes } from './routes';
import { ModuleBase } from '../../shared/modules';

export class DemoModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
